// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1227":"e72d54a8","1473":"e72d54a8","2498":"e72d54a8","3057":"e72d54a8","4494":"e72d54a8","4622":"e72d54a8","5890":"e72d54a8","6390":"e72d54a8","6656":"e72d54a8","7134":"e72d54a8","8351":"e72d54a8"}[chunkId] + ".chunk.css";
};